<template>
  <div
    :class="[
      ns.b(),
      ns.m(vertical ? 'vertical' : 'horizontal'),
      ns.is('no-spacing', noSpacing),
    ]"
    :style="dividerStyle"
    role="separator"
    data-test-name="divider"
  >
    <div
      v-if="$slots.default && !vertical"
      :class="[ns.e('text'), ns.is(contentPosition)]"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useNamespace } from '@bigin/hooks'
import { dividerProps } from './divider'
import type { CSSProperties } from 'vue'

defineOptions({
  name: 'BDivider',
})
const props = defineProps(dividerProps)
const ns = useNamespace('divider')
const dividerStyle = computed(() => {
  return ns.cssVar({
    'border-style': props.borderStyle,
  }) as CSSProperties
})
</script>
